import React from 'react';

import { RelationStatus } from '../../types/businessRelations';
import StatusRelationsTab from '../shared/StatusRelationsTab';

const SuspendedAccounts: React.FC = () => {
  return (
    <StatusRelationsTab
      status={RelationStatus.SUSPENDED}
      title="Empresas activas con cancelación efectiva al cierre de ciclo"
      emptyStateType="suspended"
      showDaysUntilMonthEnd={true}
    />
  );
};

export default SuspendedAccounts;
